import styled from '@emotion/styled';
import { Magnetic as Mi } from "../../styles";
export const StyledRequiredIndicator = styled('div') `
	width: ${Mi.requiredIndicatorWidth};
	height: ${Mi.requiredIndicatorHeight};
	margin-right: ${Mi.requiredIndicatorMarginRight};
	background-image: ${props => props.fulfilled
    ? Mi.requiredIndicatorBackgroundImageFilled
    : Mi.requiredIndicatorBackgroundImage};
`;
//# sourceMappingURL=styles.js.map